import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { CommonHeader } from "components/common/CommonHeader";
import { DataGrid } from "components/DataGrid/DataGrid";
import { amendPOColumnDefs } from "components/DataGrid/columnDefinitions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { AddDialog } from "./AddDialog";
import { RemoveDialog } from "./RemoveDialog";
import { ConfirmationDialog } from "./ConfirmationDialog";
import { PAGE, PO_ELEMENTS, PO_ITEM_STATUS, PO_STATUS } from "../common/CONSTANTS";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { amendPoPatch } from "redux/actions/amendPOAction";
import { encryptString } from "components/common/EncryptDecrypt";
import { searchPO } from "redux/actions/searchPOAction";
import { poSearchOpportunities } from "redux/actions/poSearchOpportunitiesAction";
import dayjs from "dayjs";
import {
  handleAmendCasesEdit,
  handleAmendPalletsEdit,
} from "components/DataGrid/utils";
import { AmendPoHeader } from "./AmendPoHeader";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ReactDOM from "react-dom/client";
import {
  getFormattedDate,
  getDestinationName,
} from "components/common/Utility";
import {
  getTotalCasesCount,
  getTotalBasesCount,
  getTotalPalletCount,
  getTotalWagonsCount,
} from "./calculations";
import jsPDF from "jspdf";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { RESET_PO_AMEND_PATCH } from "redux/actions/action-type";
import {
  areAllDatesValid,
  getUpdatedItems,
  getUpdatedHeader,
  determineHeaderStatus,
  createAmendPayload,
} from "./utils";
import { showErrorMessageByCode } from "services/commonServices";
import { getCancelPOStatusToSend } from "components/common/POUtils";

export const AmendPO = () => {
  const [handball, setHandball] = useState();
  const [rounding, setRounding] = useState();
  const [dialog, setDialog] = useState(false);
  const [addDialog, setAddDialog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [amendItems, setAmendItems] = useState([]);
  const [overseas, setOverseas] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnDefs, setColumnDefs] = useState();
  const [showSpinner, setShowSpinner] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const manualPoDataForAmend = useSelector((state) => state.searchPO);
  const poResponse = manualPoDataForAmend.searchPOResponse.data;
  const { isSearchLoading } = manualPoDataForAmend;
  const searchOpportunities = useSelector(
    (state) => state.poSearchOpportunities
  );
  const {
    isPOAmendPatchLoading,
    isPOAmendPatchSuccess,
    isPOAmendPatchError,
    amendPatchError,
  } = useSelector((state) => state.poAmendPatch);

  const { locationResponse } = useSelector((state) => state.locations);
  const userType = useSelector((state) => state.user);
  const { accessiblePages } = userType.userType;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { orderId, reason } = location.state;
  const loginResponse = userType.loginResponse;
  const [headerData, setHeaderData] = useState();
  const [accessibleButtonlist, setAccessibleButtonlist] = useState([]);

  const {
    searchOrderOpportunitiesData: searchOppData,
    isPOSearchOpportunitiesLoading,
    searchOpportunitiesError,
  } = searchOpportunities;

  const noOfOrders = 1;
  const manualPoAmendData = {
    orderId: poResponse?.[0]?.orderId,
    supplierId: poResponse?.[0]?.supplierId,
    supplierName: poResponse?.[0]?.supplierName,
    shipToLocationId: poResponse?.[0]?.shipToLocationId,
    shipToLocationName: poResponse?.[0]?.shipToLocationName,
    destination: poResponse?.[0]?.shipToLocationId,
    category: poResponse?.[0]?.category,
    deliveryMethod: poResponse?.[0]?.deliveryMethod,
    palletPerWagon: poResponse?.[0]?.palletPerWagon,
    rounding: poResponse?.[0]?.isQuantityRounded,
    originalStatus: poResponse?.[0]?.status,
    header: [
      {
        poIdentifier: poResponse?.[0]?.extOrderId,
        orderDate: dayjs(poResponse?.[0]?.orderDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),

        deliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),
      },
    ],
    rowData: poResponse?.[0]?.items
      ?.filter((item) => item.status !== PO_ITEM_STATUS.REMOVE && item.status !== PO_ITEM_STATUS.INACTIVE)
      .map((item) => ({
        ...item,
        selected: false,
        poIdentifier: poResponse?.[0]?.extOrderId,
        packId: item.packId,
        itemId: item.itemId,
        itemDescription: item.itemDescription,
        packSize: item.packSize,
        deliveryMethod: poResponse?.[0]?.deliveryMethod,
        orderDate: dayjs(poResponse?.[0]?.orderDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),

        deliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),
        casesPerLayer: item.casesPerLayer,
        layerPerPallet: item.layerPerPallet,
        isHandball: poResponse?.[0]?.isHandball,
        isOverseas: poResponse?.[0]?.isOverseas,
        isQuantityRounded: poResponse?.[0]?.isQuantityRounded,
        supplierId: poResponse?.[0]?.supplierId,
        supplierSiteId: poResponse?.[0]?.supplierSiteId,
        stockOnHand: item.stockOnHand,
        stockOnOrder: item.stockOnOrder,
        availableCover: item.availableCover,
        averageShipment: item.averageShipment,
        shipToLocationId: poResponse?.[0]?.shipToLocationId,
        quantityOrdered:
          item.quantityOrdered === null ? 0 : item.quantityOrdered,
        palletQuantity: item.palletQuantity === null ? 0 : item.palletQuantity,
        originalQuantityOrdered: Math.round(item.quantityOrdered * 100) / 100,
        originalPalletQuantity: Math.round(item.palletQuantity * 100) / 100,
        palletPerWagon: poResponse?.[0]?.palletPerWagon,
        originalOrderDate: dayjs(poResponse?.[0]?.orderDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),
        originalDeliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
          "YYYY-MM-DD[T]00:00:00"
        ),
        originalStatus: item.status,
        originalPOStatus: poResponse?.[0]?.status,
        orderMultipleQuantity: item.orderMultipleQuantity,
        minimumOrderQuantity: item.minimumOrderQuantity,
        orderId: poResponse?.[0]?.orderId,
      })),
  };

  useEffect(() => {
    setAccessibleButtonlist(accessiblePages[PAGE.AMEND_PO.key]);
  }, [accessiblePages]);

  const onValidItemAdded = (items) => {
    const newRows = items.map((item) => ({
      ...item,
      packId: item.packId,
      itemId: item.itemId,
      itemDescription: item.itemDescription,
      packSize: item.packSize,
      stockOnHand: item.stockOnHand,
      stockOnOrder: item.stockOnOrder,
      availableCover: item.availableCover,
      averageShipment: item.averageShipment,
      quantityOrdered:
        item.quantityOrdered === null ? 0 : item.quantityOrdered,
      palletQuantity: item.palletQuantity === null ? 0 : item.palletQuantity,
      originalQuantityOrdered: Math.round(item.quantityOrdered * 100) / 100,
      originalPalletQuantity: Math.round(item.palletQuantity * 100) / 100,
      originalOrderDate: dayjs(item.orderDate).format(
        "YYYY-MM-DD[T]00:00:00"
      ),
      originalDeliveryDate: dayjs(item.deliveryDate).format(
        "YYYY-MM-DD[T]00:00:00"
      ),
      addedItem: true,
      originalStatus: item.status,
      originalPOStatus: poResponse?.[0]?.status,
      orderMultipleQuantity: item.orderMultipleQuantity,
      minimumOrderQuantity: item.minimumOrderQuantity,
      orderId: poResponse?.[0]?.orderId,
    }));

    setAmendItems([...amendItems, ...newRows]);
    onAddDialogClose();
  };

  useEffect(() => {
    if (poResponse && poResponse.length > 0) {
      const poData = poResponse[0];
      setHeaderData({
        ...poData,
        shipToLocationId: poData?.shipToLocationId,
        shipToLocationName: poData?.shipToLocationName
          ? poData?.shipToLocationName
          : null,
      });
    }
    const manualPoAmendData = {
      orderId: poResponse?.[0]?.orderId,
      supplierId: poResponse?.[0]?.supplierId,
      destination: poResponse?.[0]?.shipToLocationId,
      category: "",
      deliveryMethod: poResponse?.[0]?.deliveryMethod,
      palletPerWagon: "",
      rounding: poResponse?.[0]?.isQuantityRounded,
      originalStatus: poResponse?.[0]?.status,
      header: [
        {
          poIdentifier: poResponse?.[0]?.extOrderId,
          orderDate: dayjs(poResponse?.[0]?.orderDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),

          deliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),
        },
      ],
      rowData: poResponse?.[0]?.items
        ?.filter(
          (item) => item.status !== PO_ITEM_STATUS.REMOVE && item.status !== PO_ITEM_STATUS.INACTIVE
        )
        .map((item) => ({
          ...item,
          selected: false,
          poIdentifier: poResponse?.[0]?.orderId
            ? poResponse?.[0]?.orderId
            : poResponse?.[0]?.extOrderId,
          packId: item.packId,
          itemId: item.itemId,
          itemDescription: item.itemDescription,
          packSize: item.packSize,
          category: item.category,
          deliveryMethod: poResponse?.[0]?.deliveryMethod,
          orderDate: dayjs(poResponse?.[0]?.orderDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),

          deliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),
          casesPerLayer: item.casesPerLayer,
          layerPerPallet: item.layerPerPallet,
          isHandball: poResponse?.[0]?.isHandball,
          isOverseas: poResponse?.[0]?.isOverseas,
          isQuantityRounded: poResponse?.[0]?.isQuantityRounded,
          isHandballOriginal: poResponse?.[0]?.isHandball,
          isOverseasOriginal: poResponse?.[0]?.isOverseas,
          isQuantityRoundedOriginal: poResponse?.[0]?.isQuantityRounded,
          supplierId: poResponse?.[0]?.supplierId,
          supplierSiteId: poResponse?.[0]?.supplierSiteId,
          stockOnHand: item.stockOnHand,
          stockOnOrder: item.stockOnOrder,
          availableCover: item.availableCover,
          averageShipment: item.averageShipment,
          shipToLocationId: poResponse?.[0]?.shipToLocationId,
          quantityOrdered:
            item.quantityOrdered === null ? 0 : item.quantityOrdered,
          palletQuantity:
            item.palletQuantity === null ? 0 : item.palletQuantity,
          originalQuantityOrdered: Math.round(item.quantityOrdered * 100) / 100,
          originalPalletQuantity: Math.round(item.palletQuantity * 100) / 100,
          palletPerWagon: poResponse?.[0]?.palletPerWagon,
          originalOrderDate: dayjs(poResponse?.[0]?.orderDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),
          originalDeliveryDate: dayjs(poResponse?.[0]?.deliveryDate).format(
            "YYYY-MM-DD[T]00:00:00"
          ),
          originalComments: poResponse?.[0]?.userComments,
          totalCases: poResponse?.[0]?.totalCasesCount,
          totalPallets: poResponse?.[0]?.totalPalletCount,
          totalBases: poResponse?.[0]?.totalBasesCount,
          totalWagons: poResponse?.[0]?.totalWagonsCount,
          originalStatus: item.status,
          originalPOStatus: poResponse?.[0]?.status,
          orderMultipleQuantity: item.orderMultipleQuantity,
          minimumOrderQuantity: item.minimumOrderQuantity,
          orderId: poResponse?.[0]?.orderId,
        })),
    };

    setAmendItems(manualPoAmendData?.rowData);
    const newRounding = manualPoAmendData?.rowData?.[0]?.isQuantityRounded;
    const newHandball = manualPoAmendData?.rowData?.[0]?.isHandball;
    const newOverseas = manualPoAmendData?.rowData?.[0]?.isOverseas;

    if (newRounding !== rounding) {
      setRounding(newRounding);
    }
    if (newHandball !== handball) {
      setHandball(newHandball);
    }
    if (newOverseas !== overseas) {
      setOverseas(newOverseas);
    }
  }, [poResponse]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isPOAmendPatchSuccess) {
      dispatch({ type: RESET_PO_AMEND_PATCH });
      setDialogOpen(true);

      const searchCriteria = {
        extOrderId: orderId,
      };
      callFetchOrders(searchCriteria);
    }
  }, [isPOAmendPatchSuccess, orderId]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isPOAmendPatchError && amendPatchError) {
      dispatch({ type: RESET_PO_AMEND_PATCH });
      const { errTitle, errContent } = showErrorMessageByCode(amendPatchError);
      dispatch(showNotificationDialog(errTitle, errContent, "Ok"));
    }
  }, [isPOAmendPatchError, amendPatchError, dispatch]);

  useEffect(() => {
    const calculateTotalCases = () => {
      const poField = rounding ? "quantityOrderedRounded" : "quantityOrdered";
      const result = amendItems.reduce((total, item) => {
        const cases = Number(item[poField]) || 0;
        return total + cases;
      }, 0);

      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          totalCases: result,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    };

    const calculateTotalPallets = () => {
      const poField = rounding ? "palletQuantityRounded" : "palletQuantity";
      const sum = amendItems.reduce((total, item) => {
        const pallets = Number(item[poField]) || 0;
        return total + pallets;
      }, 0);

      const result = Number(sum.toFixed(2));
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          totalPallets: result,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    };

    const calculateTotalBases = () => {
      const poField = "palletQuantityRounded";
      const sum = amendItems.reduce((total, item) => {
        const pallets = Number(item[poField]) || 0;
        return total + pallets;
      }, 0);

      const result = Math.ceil(sum);
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          totalBases: result,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    };

    const calculateTotalWagons = () => {
      const poField = rounding ? "palletQuantityRounded" : "palletQuantity";
      const sum = amendItems.reduce((total, item) => {
        const pallets = Number(item[poField]) || 0;
        return total + pallets;
      }, 0);

      const result = Math.ceil(sum / amendItems[0].palletPerWagon) || 0;
      setAmendItems((prevItems) => {
        const updatedItems = prevItems.map((item) => ({
          ...item,
          totalWagons: result,
        }));

        return JSON.stringify(updatedItems) !== JSON.stringify(prevItems)
          ? updatedItems
          : prevItems;
      });
    };

    if (amendItems && amendItems.length > 0) {
      calculateTotalCases();
      calculateTotalPallets();
      calculateTotalBases();
      calculateTotalWagons();
    }
  }, [amendItems, rounding]);

  const handleHandballToggle = () => {
    setHandball(!handball);
  };

  const handleOverseasToggle = () => {
    setOverseas(!overseas);
  };

  const handleRoundingToggle = () => {
    setRounding(!rounding);
  };

  const handleRemoveItem = () => {
    if (!areAllDatesValid(amendItems)) {
      dispatch(
        showNotificationDialog(
          "Invalid Dates",
          "Please enter valid order & delivery dates and try again",
          "Ok"
        )
      );
    } else {
      setDialog(true);
    }
  };

  const onDialogClose = () => {
    setDialog(false);
  };

  const handleAddItem = () => {
    setAddDialog(true);
  };

  const onAddDialogClose = () => {
    setAddDialog(false);
  };

  const handleConfirmRemoveItem = async () => {
    if (!areAllDatesValid(amendItems)) {
      dispatch(
        showNotificationDialog(
          "Invalid Dates",
          "Please enter valid order & delivery dates and try again",
          "Ok"
        )
      );
      return;
    }

    const originalPOStatus = amendItems[0].originalPOStatus;

    const updatedData = amendItems.filter(
      (item) =>
        !selectedRows.some(
          (selectedItem) =>
            selectedItem.packId === item.packId &&
            selectedItem.itemId === item.itemId
        )
    );

    const totalCasesCount = getTotalCasesCount(updatedData, rounding);
    const totalPalletCount = getTotalPalletCount(updatedData, rounding);
    const totalBasesCount = getTotalBasesCount(updatedData, rounding);
    const totalWagonsCount = getTotalWagonsCount(updatedData, rounding);

    const updatedItems = getUpdatedItems(
      amendItems,
      rounding,
      selectedRows,
      originalPOStatus,
      false, // Do not allow inactivation of empty items
      false
    );

    let updatedHeader = getUpdatedHeader(amendItems);

    const allAddedItems = updatedItems.every((item) => item.addedItem);
    const noItemChanges =
      updatedItems.length === 0 &&
      Object.keys(updatedHeader).length === 4 &&
      allAddedItems;

    if (noItemChanges) {
      dispatch(
        showNotificationDialog(
          "No Changes Detected",
          "No changes were made to the order. Please modify it before confirming.",
          "Ok"
        )
      );
      onDialogClose();
      return;
    }

    if (updatedData.length === 0) {
      updatedHeader = { ...updatedHeader, status: getCancelPOStatusToSend(originalPOStatus) };
    } else {
      updatedHeader = determineHeaderStatus(
        updatedItems,
        amendItems,
        updatedHeader,
        originalPOStatus
      );
    }

    updatedHeader = {
      ...updatedHeader,
      totalCasesCount: totalCasesCount,
      totalPalletCount: totalPalletCount,
      totalBasesCount: totalBasesCount,
      totalWagonsCount: totalWagonsCount,
    };

    const amendPayload = await createAmendPayload(
      updatedHeader,
      updatedItems,
      reason,
      loginResponse
    );

    setDialog(false);
    dispatch(amendPoPatch(amendPayload, orderId));

    const searchCriteria = {
      extOrderId: orderId,
    };
    callFetchOrders(searchCriteria);
  };

  const handleConfirmAddItem = (pinValues) => {
    if (!pinValues) return;

    const pinArray = pinValues;

    let payload = {
      packIds: pinArray.map((pin) => Number(pin)),
      shipToLocationId: amendItems[0].shipToLocationId,
      orderDate: dayjs(amendItems[0].orderDate).format("YYYY-MM-DD"),
      supplierSiteId: amendItems[0].supplierId,
    };

    dispatch(poSearchOpportunities(payload));
  };

  useEffect(() => {
    const searchCriteria = {
      extOrderId: orderId,
    };
    callFetchOrders(searchCriteria);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const callFetchOrders = async (searchCriteria) => {
    const encryptedEmailId = await encryptString(loginResponse?.email);
    const payload = {
      params: {
        purchaseOrder: searchCriteria,
        userId: encryptedEmailId,
      },
      limit: 10,
      offset: 0,
    };
    dispatch(searchPO(payload));
  };

  const onCellValueChanged = (event) => {
    const row = event.data;

    if (!row.hasOwnProperty("originalQuantityOrdered")) {
      row.originalQuantityOrdered = row.quantityOrdered;
    }
    if (!row.hasOwnProperty("originalPalletQuantity")) {
      row.originalPalletQuantity = row.palletQuantity;
    }
    if (!row.hasOwnProperty("originalOrderDate")) {
      row.originalOrderDate = row.orderDate;
    }
    if (!row.hasOwnProperty("originalDeliveryDate")) {
      row.originalDeliveryDate = row.deliveryDate;
    }

    if (event.colDef.field === "selected") {
      if (row.selected) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(
          selectedRows.filter((selectedRow) => selectedRow !== row)
        );
      }
    }
  };

  const handleConfirmAmend = async () => {
    if (!areAllDatesValid(amendItems)) {
      dispatch(
        showNotificationDialog(
          "Invalid Dates",
          "Please enter valid order & delivery dates and try again",
          "Ok"
        )
      );
      return;
    }

    const originalPOStatus = amendItems[0].originalPOStatus;
    const updatedItems = getUpdatedItems(
      amendItems,
      rounding,
      [], // no selected rows
      originalPOStatus,
      true, // allow inactivation for empty items in draft
      true
    );

    let updatedHeader = getUpdatedHeader(amendItems);

    const noItemChanges =
      updatedItems.length === 0 && Object.keys(updatedHeader).length === 4;
    const allowWithoutChanges =
      originalPOStatus === PO_STATUS.DRAFT || originalPOStatus === PO_STATUS.PENDING;

    if (noItemChanges && !allowWithoutChanges) {
      dispatch(
        showNotificationDialog(
          "No Changes Detected",
          "No changes were made to the order. Please modify it before confirming.",
          "Ok"
        )
      );
      return;
    }

    updatedHeader = determineHeaderStatus(
      updatedItems,
      amendItems,
      updatedHeader,
      originalPOStatus,
      true
    );

    const amendPayload = await createAmendPayload(
      updatedHeader,
      updatedItems,
      reason,
      loginResponse
    );

    setIsSaved(false);
    dispatch(amendPoPatch(amendPayload, orderId));
  };

  const handleSave = async () => {
    if (!areAllDatesValid(amendItems)) {
      dispatch(
        showNotificationDialog(
          "Invalid Dates",
          "Please enter valid order & delivery dates and try again",
          "Ok"
        )
      );
      return;
    }

    const updatedItems = amendItems
      ?.filter((item) => {
        return (
          item.quantityOrdered !== item.originalQuantityOrdered ||
          item.palletQuantity !== item.originalPalletQuantity ||
          !item.originalQuantityOrdered ||
          !item.originalPalletQuantity ||
          item.isQuantityRounded !== item.isQuantityRoundedOriginal
        );
      })
      .map((item) => {
        const payloadItem = {
          packId: item.packId,
          itemId: item.itemId,
          status: PO_ITEM_STATUS.DRAFT,
        };
        if (item.addedItem) {
          return { ...item, status: PO_ITEM_STATUS.CREATE};
        }
        if (
          item.quantityOrdered !== item.originalQuantityOrdered ||
          item.isQuantityRounded !== item.isQuantityRoundedOriginal
        ) {
          payloadItem.quantityOrdered = rounding
            ? item.quantityOrderedRounded
            : item.quantityOrdered;
        }
        if (
          item.palletQuantity !== item.originalPalletQuantity ||
          item.isQuantityRounded !== item.isQuantityRoundedOriginal
        ) {
          payloadItem.palletQuantity = rounding
            ? item.palletQuantityRounded
            : item.palletQuantity;
        }
        return payloadItem;
      });

    let updatedHeader = amendItems
      .filter((item) => {
        return (
          item.orderDate !== item.originalOrderDate ||
          item.deliveryDate !== item.originalDeliveryDate ||
          item.isHandball !== item.isHandballOriginal ||
          item.isOverseas !== item.isOverseasOriginal ||
          item.isQuantityRounded !== item.isQuantityRoundedOriginal ||
          item.comments !== item.originalComments
        );
      })
      .map(
        ({
          orderDate,
          deliveryDate,
          originalOrderDate,
          originalDeliveryDate,
          isHandball,
          isHandballOriginal,
          isOverseas,
          isOverseasOriginal,
          isQuantityRounded,
          isQuantityRoundedOriginal,
          comments,
          originalComments,
          totalCases,
          totalPallets,
          totalBases,
          totalWagons,
        }) => {
          const payloadHeader = {};
          if (orderDate !== originalOrderDate) {
            payloadHeader.orderDate = orderDate;
          }
          if (deliveryDate !== originalDeliveryDate) {
            payloadHeader.deliveryDate = deliveryDate;
          }
          if (isHandball !== isHandballOriginal) {
            payloadHeader.isHandball = isHandball;
          }
          if (isOverseas !== isOverseasOriginal) {
            payloadHeader.isOverseas = isOverseas;
          }
          if (isQuantityRounded !== isQuantityRoundedOriginal) {
            payloadHeader.isQuantityRounded = isQuantityRounded;
          }
          if (comments && comments !== originalComments) {
            payloadHeader.userComments = comments;
          }
          payloadHeader.totalCasesCount = totalCases;
          payloadHeader.totalPalletCount = totalPallets;
          payloadHeader.totalBasesCount = totalBases;
          payloadHeader.totalWagonsCount = totalWagons;
          return payloadHeader;
        }
      )[0];

    const areAllQuantitiesZero = updatedItems.every(
      (item) =>
        (item.quantityOrdered === 0 && item.palletQuantity === 0) ||
        (item.quantityOrdered === "" && item.palletQuantity === "") ||
        (item.quantityOrdered === null && item.palletQuantity === null)
    );
    if (
      updatedItems.length > 0 &&
      areAllQuantitiesZero &&
      updatedItems.length === amendItems.length
    ) {
      dispatch(
        showNotificationDialog(
          "No Quantities Entered",
          "Please enter quantity for at least 1 item in a PO",
          "Ok"
        )
      );
      return;
    } else {
      updatedHeader = { ...updatedHeader, status: PO_STATUS.DRAFT };
    }

    const encryptedEmailId = await encryptString(loginResponse?.email);
    const amendPayload = {
      ...updatedHeader,
      ...(reason !== undefined && { reasonCode: reason }),
      items: updatedItems,
      userId: encryptedEmailId,
    };

    setIsSaved(true);
    dispatch(amendPoPatch(amendPayload, orderId));
  };

  const amendCalculationOnLoad = () => {
    const truncateToTwo = (num) => Math.floor(num * 100) / 100;

    if (amendItems && amendItems.length > 0) {
      const updatedItems = amendItems.map((row) => {
        const rawValue = row.quantityOrdered;
        if (!rawValue || Number(rawValue) === 0) {
          return {
            ...row,
            quantityOrdered: null,
            quantityOrderedRounded: null,
            palletQuantity: null,
            palletQuantityRounded: null,
          };
        }

        const newValue = Number(rawValue);
        if (isNaN(newValue) || newValue < 0) return row;

        const {
          casesPerLayer,
          layerPerPallet,
          orderMultipleQuantity,
          minimumOrderQuantity,
        } = row;

        const totalCasesPerPallet = casesPerLayer * layerPerPallet;
        const roundedCases =
          newValue <= minimumOrderQuantity
            ? minimumOrderQuantity
            : Math.ceil(newValue / orderMultipleQuantity) *
              orderMultipleQuantity;

        const palletQuantity = newValue / totalCasesPerPallet;
        const palletQuantityRounded = roundedCases / totalCasesPerPallet;

        return {
          ...row,
          quantityOrdered: truncateToTwo(newValue),
          quantityOrderedRounded: Math.round(roundedCases * 100) / 100,
          palletQuantity: truncateToTwo(palletQuantity),
          palletQuantityRounded: Math.round(palletQuantityRounded * 100) / 100,
        };
      });

      setAmendItems(updatedItems);
    }
  };

  useEffect(() => {
    amendCalculationOnLoad();
  }, [rounding]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (noOfOrders) {
      const dynamicColumns = {
        children: [
          {
            headerName: "Order Qty (Cases)",
            field: rounding ? "quantityOrderedRounded" : "quantityOrdered",
            editable: true,
            width: 80,
            minWidth: 80,
            maxWidth: 90,
            filter: false,
            headerClass: "centered-header",
            cellStyle: { textAlign: "right" },
            valueSetter: (params) =>
              handleAmendCasesEdit(params, setAmendItems),
            cellEditor: "agNumberCellEditor",
          },
          {
            headerName: "Order Qty (Pallets)",
            field: rounding ? "palletQuantityRounded" : "palletQuantity",
            editable: true,
            width: 80,
            minWidth: 80,
            maxWidth: 90,
            filter: false,
            headerClass: "centered-header",
            cellStyle: { textAlign: "right" },
            valueSetter: (params) => {
              return handleAmendPalletsEdit(params, setAmendItems);
            },
            valueFormatter: ({ value }) => {
              if (value == null) return "";
              return (Math.floor(value * 100) / 100).toFixed(2); // Truncate and format
            },
            cellEditor: "agNumberCellEditor",
          },
        ],
      };

      setColumnDefs([...amendPOColumnDefs, dynamicColumns]);
    }
  }, [noOfOrders, rounding]);

  const [loading, setLoading] = useState(false);

  const handleDownloadPDF = () => {
    setLoading(true);
    setShowSpinner(true);
    const firstItem = amendItems[0];
    const hiddenDiv = document.createElement("div");
    document.body.appendChild(hiddenDiv);
    const root = ReactDOM.createRoot(hiddenDiv);

    root.render(
      <POPDFContent
        amendItems={amendItems}
        headerData={headerData}
        rounding={rounding}
        locationResponse={locationResponse}
      />
    );
    const pdf = new jsPDF("p", "mm", "a4");

    pdf.html(hiddenDiv, {
      callback: function (doc) {
        root.unmount();
        document.body.removeChild(hiddenDiv);
        setLoading(false);
        setShowSpinner(false);
        doc.save(`Amend-PO-${firstItem.poIdentifier || "download"}.pdf`);
      },
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 190,
      windowWidth: hiddenDiv.scrollWidth,
    });
  };

  return (
    <>
      <div className="mainPageStyling">
        {(isSearchLoading ||
          isPOSearchOpportunitiesLoading ||
          isPOAmendPatchLoading ||
          showSpinner) && (
          <Backdrop
            sx={{
              color: "#fff",
              flexDirection: "column",
              zIndex: (theme) => theme.zIndex.modal + 1,
            }}
            open={true}
          >
            <CircularProgress color="inherit" />

            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Loading...
            </Typography>
          </Backdrop>
        )}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            {PAGE.AMEND_PO.label}
          </Typography>
        </div>

        <div style={{ marginBottom: "10px" }} className="labelControl">
          <CommonHeader
            data={headerData}
            handball={handball}
            handleHandballToggle={handleHandballToggle}
            rounding={rounding}
            handleRoundingToggle={handleRoundingToggle}
            overseas={overseas}
            handleOverseasToggle={handleOverseasToggle}
          />
          <AmendPoHeader
            data={amendItems}
            rounding={rounding}
            handball={handball}
            overseas={overseas}
            setAmendItems={setAmendItems}
          />
        </div>
        <div
          style={{ width: "100%", height: "calc( 100vh - 335px)" }}
          className="amendCategoryStyle"
        >
          <DataGrid
            rowData={amendItems}
            columnDefs={columnDefs}
            onCellValueChanged={onCellValueChanged}
            defaultColDef={{
              flex: 1,
              sortable: false,
              filter: false,
              resizable: false,
              wrapHeaderText: true,
              autoHeaderHeight: true,
              headerClass: "header-wrap",
              autoSizeStrategy: { type: "fitCellContents" },
            }}
          />
        </div>

        <Grid
          container
          spacing={2}
          sx={{ marginTop: "10px", marginBottom: "20px" }}
          className="paddingTop0 commonButtons marginBottom0"
        >
          <Grid item xs={12} sm={6} md={6} className="innerPadding">
            {accessibleButtonlist?.includes(
              PO_ELEMENTS.AMEND_PO.CONFIRM_BUTTON
            ) && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleRemoveItem}
                style={{
                  marginRight: "8px",
                }}
                disabled={selectedRows && selectedRows.length === 0}
              >
                Remove Item
              </Button>
            )}
            {accessibleButtonlist?.includes(
              PO_ELEMENTS.AMEND_PO.DOWNLOAD_AS_PDF_BUTTON
            ) &&
              amendItems &&
              amendItems.length > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadPDF}
                  disabled={loading}
                >
                  {loading ? "Generating PDF..." : "Download as PDF"}
                </Button>
              )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="innerPadding"
            style={{
              textAlign: "right",
            }}
          >
            {accessibleButtonlist?.includes(
              PO_ELEMENTS.AMEND_PO.CONFIRM_BUTTON
            ) && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddItem}
                style={{
                  marginRight: "8px",
                }}
              >
                Add Item
              </Button>
            )}
            {accessibleButtonlist?.includes(PO_ELEMENTS.AMEND_PO.SAVE_BUTTON) &&
              manualPoAmendData.originalStatus === "draft" && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  style={{
                    marginRight: "8px",
                  }}
                >
                  Save
                </Button>
              )}
            {accessibleButtonlist?.includes(
              PO_ELEMENTS.AMEND_PO.CONFIRM_BUTTON
            ) && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleConfirmAmend}
                style={{
                  marginRight: "8px",
                }}
              >
                Confirm
              </Button>
            )}
            {accessibleButtonlist?.includes(
              PO_ELEMENTS.AMEND_PO.BACK_BUTTON
            ) && (
              <Button
                variant="contained"
                color="secondary"
                onClick={() =>
                  navigate(PAGE.PO_SUMMARY.url, {
                    state: {
                      retainSearchCriteria: true,
                    },
                  })
                }
              >
                Back
              </Button>
            )}
          </Grid>
        </Grid>
      </div>

      <RemoveDialog
        dialog={dialog}
        onDialogClose={onDialogClose}
        onConfirm={handleConfirmRemoveItem}
      />
      <AddDialog
        addDialog={addDialog}
        onAddDialogClose={onAddDialogClose}
        handleConfirmAddItem={handleConfirmAddItem}
        searchOpportunitiesError={searchOpportunitiesError}
        searchOpportunitiesData = {searchOppData}
        onValidItemAdded = {onValidItemAdded}
        amendItems={amendItems}
      />
      <ConfirmationDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        isSaved={isSaved}
        setIsSaved={setIsSaved}
      />
    </>
  );
};

//  PDF-only hidden component
const POPDFContent = ({
  amendItems,
  headerData,
  rounding,
  locationResponse,
}) => (
  <div style={{ fontFamily: "Arial, sans-serif", padding: 20 }}>
    <hr style={{ margin: "0", border: "2px solid black" }} />
    {/* Purchase Order Header */}
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <thead>
        <tr>
          <td colSpan="3" style={{ paddingBottom: "8px" }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "24px",
                marginBottom: "0",
              }}
            >
              Purchase Order No.: {amendItems[0].poIdentifier}
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          {/* Registered Office */}
          <td style={{ width: "33%", verticalAlign: "top", padding: "8px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              Registered Office:
            </div>
            <div>
              Wm Morrison Supermarkets LTD <br />
              Hilmore House, Gain Lane,
              <br />
              Bradford BD3 7DL
            </div>
          </td>

          {/* Order Query */}
          <td style={{ width: "34%", verticalAlign: "top", padding: "8px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              Order Query:
            </div>
            <div>
              In case of order query please telephone:
              <br />
              Fresh 0845 611 5000 /<br />
              Ambient 0845 611 5601
            </div>

            {(headerData.status ===PO_STATUS.AMENDED ||
              headerData.status === PO_STATUS.SOMS_AMENDED) && (
              <div style={{ marginTop: "8px" }}>
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Amendment Indicator:
                </span>
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "16px",
                    borderBottom: "2px solid black",
                    borderRight: "2px solid black",
                    transform: "rotate(45deg)",
                    marginLeft: "6px",
                  }}
                />
              </div>
            )}
          </td>

          {/* Logo Placeholder */}
          <td
            style={{
              width: "33%",
              verticalAlign: "top",
              padding: "8px",
              textAlign: "right",
            }}
          >
            {/* <img alt="Morrisons" src={morrisonsLogo} style={{ maxHeight: "50px" }} /> */}
          </td>
        </tr>
      </tbody>
    </table>
    <hr style={{ margin: "0 0 20px", border: "2px solid black" }} />

    <table
      style={{
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: "10px",
        marginTop: "10px",
        marginBottom: "20px",
      }}
    >
      <tbody>
        <tr>
          {/* Purchase Order Info */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Purchase Order Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ fontSize: "14px", width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Purchase Order No.:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {amendItems[0].poIdentifier}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Order Date:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {getFormattedDate(amendItems[0].orderDate)}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Delivery Date:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {getFormattedDate(amendItems[0].deliveryDate)}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Supplier Info */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Supplier Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ fontSize: "14px", width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Order To:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {headerData?.supplierName}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Supplier Site:
                  </td>
                  <td style={{ padding: "4px 0" }}>{headerData?.supplierId}</td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Order Quantity Totals */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Order Quantity Totals
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ fontSize: "14px", width: "100%" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      padding: "4px 0",
                      width: "40%",
                    }}
                  >
                    Total Cases:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {amendItems[0].totalCases}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Total Pallets:
                  </td>
                  <td style={{ adding: "4px 0" }}>
                    {amendItems[0].totalPallets}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Total Bases:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {amendItems[0].totalBases}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          {/* Delivery Info */}
          <td
            style={{
              width: "25%",
              border: "1px solid black",
              padding: "8px",
              verticalAlign: "top",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Delivery Information
            </div>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid black",
                margin: "4px 0 8px 0",
              }}
            />
            <table style={{ fontSize: "14px", width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Location ID:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {headerData?.shipToLocationId || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                    Location Name:
                  </td>
                  <td style={{ padding: "4px 0" }}>
                    {headerData?.shipToLocationName ||
                      getDestinationName(
                        locationResponse,
                        headerData?.shipToLocationId
                      )}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        textAlign: "center",
      }}
    >
      <thead>
        <tr
          style={{
            borderTop: "2px solid black",
            borderBottom: "2px solid black",
          }}
        >
          <th style={{ padding: "8px", textAlign: "left" }}>PIN</th>
          <th style={{ padding: "8px", textAlign: "left" }}>Description</th>
          <th style={{ padding: "8px" }}>Order Qty (Cases)</th>
          <th style={{ padding: "8px" }}>Order Qty (Pallets)</th>
        </tr>
      </thead>
      <tbody>
        {amendItems?.map((item, idx) => (
          <tr key={idx}>
            <td style={{ padding: "4px", textAlign: "left" }}>{item.packId}</td>
            <td style={{ padding: "4px", textAlign: "left" }}>
              {item.itemDescription}
            </td>
            <td style={{ padding: "4px" }}>
              {rounding ? item.quantityOrderedRounded : item.quantityOrdered}
            </td>
            <td style={{ padding: "4px" }}>
              {rounding ? item.palletQuantityRounded : item.palletQuantity}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
